// Catalog (campaign list) interactions, relocated from inline scripts that lived inside
// the Naja snippets of Campaign/default.latte. Everything is bound through delegation on
// document and on the shared naja instance, so it keeps working after Naja re-renders the
// filter and grid snippets — no per-snippet re-binding needed.

import naja from 'naja';

// Matches the height of #catalog-parent to its content. Re-run after every naja request
// because the campaign grid (and thus the content height) changes when filters are applied.
function resizeCatalog() {
  const parent = document.getElementById('catalog-parent');
  if (!parent) {
    return;
  }

  const child = parent.getElementsByClassName('wrapper')[0];
  parent.style.height = child.offsetHeight - 207 + 'px';
  document.body.style.height = 100 + 'px';
}

function scheduleCatalogResize() {
  setTimeout(resizeCatalog, 100);
  setTimeout(resizeCatalog, 1000);
  setTimeout(resizeCatalog, 5000);
}

// Search forms (desktop filter + mobile filter bar) navigate to the filtered listing.
document.addEventListener('submit', (event) => {
  const form = event.target.closest('form[data-catalog-search]');
  if (!form) {
    return;
  }

  event.preventDefault();
  const input = form.querySelector('input[name="search"]');
  const link = form.dataset.catalogSearch + '?search=' + encodeURIComponent(input.value);
  naja.makeRequest('GET', link, null, { history: true });
});

document.addEventListener('click', (event) => {
  // Category / country checkboxes trigger the hidden ajax link in the same label.
  const checkbox = event.target.closest('.campaign .filter label.container input[type="checkbox"]');
  if (checkbox) {
    const link = checkbox.closest('label').querySelector('a.ajax');
    if (link) {
      link.click();
    }

    return;
  }

  // Mobile filter toggle.
  const toggle = event.target.closest('.campaign .filter-mobile');
  if (toggle) {
    const filter = document.getElementById('snippet--filter');
    if (filter) {
      filter.classList.toggle('show');
    }
  }
});

const scrollToCatalog = () => {
  const catalog = document.getElementById('snippet--campaigns');
  const header = document.querySelector('header');
  if (!catalog) {
    return;
  }

  const top = catalog.getBoundingClientRect().top + window.scrollY - (header ? header.offsetHeight : 0);
  window.scrollTo({ top, behavior: 'smooth' });
};

naja.uiHandler.addEventListener('interaction', (event) => {
  if (event.detail.element.closest('.catalog-pagination')) {
    event.detail.options.scrollToCatalog = true;
  }
});

naja.addEventListener('complete', (event) => {
  if (event.detail.options.scrollToCatalog) {
    scrollToCatalog();
  }
});

scheduleCatalogResize();
window.addEventListener('resize', resizeCatalog);
naja.addEventListener('complete', scheduleCatalogResize);
